import { documentTransforms } from './document-transforms';
import { editorTransforms } from './editor-transforms';
import { generalTransforms } from './general-transforms';
import { scrollTransforms } from './scroll-transforms';
import { selectionTransforms } from './selection-transforms';

export const ClientTransforms = {
  ...documentTransforms,
  ...editorTransforms,
  ...generalTransforms,
  ...scrollTransforms,
  ...selectionTransforms,
};
